import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const profileFilter = chooseProfileFilter()

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/bankagencies/';
    const paths = {
        endpointSave: config.endpoints.backend + 'bankagencies/save',
        endpointGetById: config.endpoints.backend + 'bankagencies/getById',
        endpointGetAllBanks: config.endpoints.backend + 'banks/getall',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Agência",
        labelTitleEdit: "Editar Agência",
        labelTitleView: 'Visualizar Agência'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'pdc_bank_id',
                    type: 'select',
                    label: 'Banco',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBanks,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6,
                },
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome da Agência',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'cgc_mf',
                    type: 'text',
                    label: 'CGC (MF)',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'phones',
                    type: 'multiinput',
                    label: 'Telefones',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Telefone',
                            type: 'phone',
                            name: 'phone',
                            validations: {
                                required: false
                            }
                        }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'manager',
                    type: 'text',
                    label: 'Gerente',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                },
                {
                    name: 'contact',
                    type: 'text',
                    label: 'Contato',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
